module.exports = __webpack_public_path__ + "img/number-2.4a0b0faa.png";